
import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch } from "react-router-dom";
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { PersistGate } from 'redux-persist/integration/react'
import indexRoutes from "routes/index.jsx";

import "assets/scss/material-dashboard-pro-react.css?v=1.4.0";

import Loading from 'components/Loading/Loading';
import { store, persistor, history } from "./redux/store";

import $ from 'jquery';
import PrivateRoute from "./routes/PrivateRoute";
import QueryStringSerializer from "./QueryStringSerializer";
import NotificationWatcher from "./NotificationWatcher";
import Api, { AuthEvents, role } from "./api/Api.js";
import ForexEndpoints from "./api/ForexEndpoints";
import { SET_LATEST_FOREX, SET_REPORT_LIST, SET_PRODUCT_LIST, SET_CUSTOMER_LIST, SET_EMAIL_LIST, SET_USER_LIST, SET_MOBISERV_DETAILS } from "./redux/types";
import ReportEndpoints from "./api/ReportEndpoints";
import ProductEndpoints from "./api/ProductEndpoints";
import CustomerEndpoints from "./api/CustomerEndpoints";
import EmailEndpoints from "./api/EmailEndpoints";
import UserEndpoints from "./api/UserEndpoints";
import _ from 'lodash';

import * as Sentry from '@sentry/browser';
import SystemEndpoints from "./api/SystemEndpoints";
import { OpsOrAbove, NotClient } from "./routes/dashboard";
//var Sentry = {  }
//import { isArray } from "util";

const Development = 'development';
const QA = 'QA';
const Live = 'Live';

const environment = process.env.NODE_ENV === Development ? Development : Live;

Sentry.init({
  dsn: 'https://a67d73d0339742b69d0fb1f2a2aee0ee@sentry.io/172542',
  environment,
});

var consoleWarn = console.warn;
var consoleError = console.error;
var consoleLog = environment === Live || environment === QA ? function () { } : console.log;
var consoleDebug = environment === Live || environment === QA ? function () { } : console.debug;
var consoleOverride = console;

const capturePossibleError = (e) => {
  if (e instanceof Error) {
    Sentry.captureException(e);
  } else {
    Sentry.captureMessage(JSON.stringify(e, null, 4), Sentry.Severity.Error);
  }
}

const capturePossibleWarning = (e) => Sentry.captureMessage(JSON.stringify(e, null, 4), Sentry.Severity.Warning);

const captureFunc = function (originalFunc, type = "debug") {
  if (environment === Development) {
    return originalFunc;
  }

  return function (...params) {
    if (params) {
      if (Array.isArray(params)) {
        if (params.length === 1) {
          if (type === "error") {
            capturePossibleError(params[0])
          } else if (type === "warn") {
            capturePossibleWarning(params[0]);
          } else {
            Sentry.addBreadcrumb(params[0]);
          }
        } else {
          var errors = [];
          var breadcrumbes = [];
          params.forEach(p => {
            if (p instanceof Error) {
              errors.push(p);
            } else {
              breadcrumbes.push(p);
            }
          });

          breadcrumbes.forEach(crumb => Sentry.addBreadcrumb(crumb));
          errors.forEach(error => {
            if (type === "error") {
              Sentry.captureException(error)
            } else if (type === "warning") {
              capturePossibleWarning(error)
            } else {
              Sentry.addBreadcrumb(error);
            }
          });
        }
      }
      originalFunc(...params);
    }
  }
}

consoleOverride.error = captureFunc(consoleError, 'error');
consoleOverride.warn = captureFunc(consoleWarn, 'warning');
consoleOverride.log = captureFunc(consoleLog, 'debug')
consoleOverride.debug = captureFunc(consoleDebug, 'debug')

if (process.env.NODE_ENV !== Development) {
  window.console = consoleOverride;
}

window.jQuery = $;
require('bootstrap');
//persistor.purge();

class App extends React.Component {

  state = {
    preloading: true
  }

  preload() {

    if (NotClient.some(_role => _role === role)) {

      Promise.all([
        Api.get(ForexEndpoints.getLatest),
        Api.get(ReportEndpoints.list),
        Api.get(ProductEndpoints.list),
        Api.get(CustomerEndpoints.list),
        Api.get(EmailEndpoints.list),
        Api.get(UserEndpoints.list)
      ])
        .then(([forex, reports, products, customers, emails, users, system]) => {

          if (forex && forex.data && _.isArray(forex.data))
            store.dispatch({ type: SET_LATEST_FOREX, payload: forex.data });
          if (reports && reports.data && _.isArray(reports.data))
            store.dispatch({ type: SET_REPORT_LIST, payload: reports.data });
          if (products && products.data && _.isArray(products.data))
            store.dispatch({ type: SET_PRODUCT_LIST, payload: products.data });
          if (customers && customers.data && _.isArray(customers.data))
            store.dispatch({ type: SET_CUSTOMER_LIST, payload: customers.data });
          if (emails && emails.data && _.isArray(emails.data))
            store.dispatch({ type: SET_EMAIL_LIST, payload: emails.data });
          if (users && users.data && _.isArray(users.data))
            store.dispatch({ type: SET_USER_LIST, payload: users.data });
          this.setState({ preloading: false });
        })
        .catch(e => {
          console.error(e);
          this.setState({ preloading: false });
        });

      if (OpsOrAbove.some(_role => _role === role))
        Api.get(SystemEndpoints.systemCredentials, { system: "mobiserv" }).then((system) => {
          if (system && system.data)
            store.dispatch({ type: SET_MOBISERV_DETAILS, payload: system.data });
        })
    } else {
      Api.get(ReportEndpoints.list)
        .then((reports) => {
          if (reports && reports.data && _.isArray(reports.data))
            store.dispatch({ type: SET_REPORT_LIST, payload: reports.data });
          this.setState({ preloading: false });
        })
        .catch(e => {
          console.error(e);
          this.setState({ preloading: false });
        });
    }
  }

  componentDidCatch(e) {
    console.error("Error Received in index.js", e);
  }

  componentDidMount() {
    if (Api.isLoggedIn() && !Api.isLocked()) {
      console.debug('Logged In - Preloading');
      this.preload();
    } else {
      console.debug('Not Logged');
      this.setState({ preloading: false });
    }
    AuthEvents.addListener("loggedIn", (data) => {
      //Sentry.setUser(data.user);
      this.setState({ preloading: true }, () => this.preload())
    });
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={<Loading overlay />} persistor={persistor}>
          {
            this.state.preloading ?
              <Loading overlay>
                <h4>&nbsp;&nbsp;&nbsp;&nbsp;Preloading...</h4>
              </Loading>
              :
              <ConnectedRouter history={history}>
                <Switch>
                  {indexRoutes.map((prop, key) => {
                    var RoutingComponent = Route;
                    if (prop.private)
                      RoutingComponent = PrivateRoute;
                    return (
                      <RoutingComponent
                        {...prop}
                        path={prop.path}
                        component={prop.component}
                        key={key}
                      />
                    );
                  })}
                </Switch>
              </ConnectedRouter>
          }
          <QueryStringSerializer />
          <NotificationWatcher />
        </PersistGate>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"), () => document.getElementById('loading_styles').remove());
